module.exports = "<p>\r\n  beta-users-details works!\r\n</p>\r\n"